import IncognitoModeError from './incognito-mode-error';

class SessionStorage {
  getItem(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (err) {
      throw new IncognitoModeError(err);
    }
  }

  setItem(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (err) {
      throw new IncognitoModeError(err);
    }
  }

  removeItem(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (err) {
      throw new IncognitoModeError(err);
    }
  }
}

export default SessionStorage;
